import { ModelNumber } from '../P300';
export class P300 {
    constructor(socket, log) {
        this.socket = socket;
        this.deviceName = 'P300';
        this.modelNumber = ModelNumber.P300;
        this.channels = {
            [ModelNumber.ANIUSB]: [
                { name: 'Dante Input 1', mute: false, volume: 1000 },
                { name: 'Dante Input 2', mute: false, volume: 1000 },
                { name: 'Dante Input 3', mute: false, volume: 1000 },
                { name: 'Dante Input 4', mute: false, volume: 1000 },
                { name: 'Analog Input', mute: false, volume: 1000 },
                { name: 'USB Input', mute: false, volume: 1000 },
                { name: 'Dante Output 1', mute: false, volume: 1000 },
                { name: 'Dante Output 2', mute: false, volume: 1000 },
                { name: 'Analog Output', mute: false, volume: 1000 },
                { name: 'USB Output', mute: false, volume: 1000 },
            ],
            [ModelNumber.IntelliMixRoom]: [
                { name: 'Mic Input 1', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 2', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 3', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 4', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 5', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 6', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 7', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 8', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 9', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 10', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 12', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 13', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 13', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 14', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 15', mute: false, volume: 1000, hasNoName: true },
                { name: 'Mic Input 16', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Input 1', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Input 2', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Input 3', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Input 4', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Input 5', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Input 6', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Input 7', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Input 8', mute: false, volume: 1000, hasNoName: true },
                { name: 'Virtual Audio Input', mute: false, volume: 1000, hasNoName: true },
                { name: 'PC Input', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Output 1', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Output 2', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Output 3', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Output 4', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Output 5', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Output 6', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Output 7', mute: false, volume: 1000, hasNoName: true },
                { name: 'Dante Output 8', mute: false, volume: 1000, hasNoName: true },
                { name: 'Virtual Audio Output', mute: false, volume: 1000, hasNoName: true },
                { name: 'PC Output', mute: false, volume: 1000, hasNoName: true },
                {
                    name: 'Automixer Output',
                    mute: false,
                    volume: 1000,
                    hasNoName: true,
                    isAutomixer: true,
                },
            ],
            [ModelNumber.MXA910]: [
                { name: 'Dante Output 1', mute: false, volume: 1000 },
                { name: 'Dante Output 2', mute: false, volume: 1000 },
                { name: 'Dante Output 3', mute: false, volume: 1000 },
                { name: 'Dante Output 4', mute: false, volume: 1000 },
                { name: 'Dante Output 5', mute: false, volume: 1000 },
                { name: 'Dante Output 6', mute: false, volume: 1000 },
                { name: 'Dante Output 7', mute: false, volume: 1000 },
                { name: 'Dante Output 8', mute: false, volume: 1000 },
                {
                    name: 'Automixer Output',
                    mute: false,
                    volume: 1000,
                    hasNoName: true,
                    isAutomixer: true,
                },
                { name: 'AEC Reference', mute: false, volume: 1000, hasNoName: true, isAecRef: true },
            ],
            [ModelNumber.P300]: [
                { name: 'Dante Input 1', mute: false, volume: 1000 },
                { name: 'Dante Input 2', mute: false, volume: 1000 },
                { name: 'Dante Input 3', mute: false, volume: 1000 },
                { name: 'Dante Input 4', mute: false, volume: 1000 },
                { name: 'Dante Input 5', mute: false, volume: 1000 },
                { name: 'Dante Input 6', mute: false, volume: 1000 },
                { name: 'Dante Input 7', mute: false, volume: 1000 },
                { name: 'Dante Input 8', mute: false, volume: 1000 },
                { name: 'Dante Input 9', mute: false, volume: 1000 },
                { name: 'Dante Input 10', mute: false, volume: 1000 },
                { name: 'Analog Input 1 (from Codec)', mute: false, volume: 1000 },
                { name: 'Analog Input 2', mute: false, volume: 1000 },
                { name: 'USB Input', mute: false, volume: 1000 },
                { name: 'Mobile Input', mute: false, volume: 1000 },
                { name: 'Dante Output 1', mute: false, volume: 1000 },
                { name: 'Dante Output 2', mute: false, volume: 1000 },
                { name: 'Analog Output 1 (to Codec)', mute: false, volume: 1000 },
                { name: 'Analog Output 2 (to Speaker)', mute: false, volume: 1000 },
                { name: 'USB Output', mute: false, volume: 1000 },
                { name: 'Mobile Output', mute: false, volume: 1000 },
                {
                    name: 'Automixer Output',
                    mute: false,
                    volume: 1000,
                    hasNoName: true,
                    isAutomixer: true,
                },
                { name: 'AEC Reference', mute: false, volume: 1000, hasNoName: true, isAecRef: true },
                { name: 'Dante Output 3', mute: false, volume: 1000 },
                { name: 'Dante Output 4', mute: false, volume: 1000 },
                { name: 'Dante Output 5', mute: false, volume: 1000 },
                { name: 'Dante Output 6', mute: false, volume: 1000 },
                { name: 'Dante Output 7', mute: false, volume: 1000 },
                { name: 'Dante Output 8', mute: false, volume: 1000 },
            ],
        };
        this.presets = [
            { name: 'Preset 1 (Empty)' },
            { name: 'Preset 2 (Empty)' },
            { name: 'Preset 3 (Empty)' },
            { name: 'Preset 4 (Empty)' },
            { name: 'Preset 5 (Empty)' },
            { name: 'Preset 6 (Empty)' },
            { name: 'Preset 7 (Empty)' },
            { name: 'Preset 8 (Empty)' },
            { name: 'Preset 9 (Empty)' },
            { name: 'Preset 10 (Empty)' },
        ];
        this.asyncHandlers = [
            {
                regExp: /^< GET (\d+) AUDIO_GAIN_HI_RES/,
                callback: (match) => {
                    const channelNumber = parseInt(match[1]);
                    const channel = this.channels[this.modelNumber][channelNumber - 1];
                    const channelKey = channelNumber.toString().padStart(2, '0');
                    if (channel === undefined || channel.isAecRef) {
                        this.socket.send(`< REP ERR >`);
                        return;
                    }
                    const value = channel.volume.toString().padStart(4, '0');
                    this.socket.send(`< REP ${channelKey} AUDIO_GAIN_HI_RES ${value} >`);
                },
            },
            {
                regExp: /^< GET (\d+) (AUDIO_MUTE|AUTOMXR_MUTE)/,
                callback: (match) => {
                    const channelNumber = parseInt(match[1]);
                    const channel = this.channels[this.modelNumber][channelNumber - 1];
                    const channelKey = channelNumber.toString().padStart(2, '0');
                    if (channel === undefined ||
                        (match[2] === 'AUTOMXR_MUTE' && !channel.isAutomixer) ||
                        (match[2] === 'AUDIO_MUTE' && channel.isAutomixer) ||
                        channel.isAecRef) {
                        this.socket.send(`< REP ERR >`);
                        return;
                    }
                    const value = channel.mute ? 'ON' : 'OFF';
                    this.socket.send(`< REP ${channelKey} ${match[2]} ${value} >`);
                },
            },
            {
                regExp: /^< GET (\d+) CHAN_NAME/,
                callback: (match) => {
                    const channelNumber = parseInt(match[1]);
                    const channels = this.channels[this.modelNumber];
                    if (channelNumber === 0) {
                        if (Object.values(channels).every(chan => chan.hasNoName)) {
                            this.socket.send(`< REP ERR >`);
                        }
                        else {
                            for (let i = 0; i < channels.length; i++) {
                                const channel = channels[i];
                                if (channel.hasNoName)
                                    continue;
                                const channelKey = (i + 1).toString().padStart(2, '0');
                                const name = this.p300String(channel.name, 31);
                                this.socket.send(`< REP ${channelKey} CHAN_NAME ${name} >`);
                            }
                        }
                    }
                    else {
                        const channel = channels[channelNumber - 1];
                        if (channel === undefined || channel.hasNoName) {
                            this.socket.send(`< REP ERR >`);
                        }
                        else {
                            const channelKey = channelNumber.toString().padStart(2, '0');
                            const name = this.p300String(channel.name, 31);
                            this.socket.send(`< REP ${channelKey} CHAN_NAME ${name} >`);
                        }
                    }
                },
            },
            {
                regExp: /^< GET DEVICE_ID/,
                callback: (match) => {
                    const deviceId = this.p300String(`${this.deviceName}-012345`, 31);
                    this.socket.send(`< REP DEVICE_ID ${deviceId} >`);
                },
            },
            {
                regExp: /^< GET FW_VER/,
                callback: (match) => {
                    this.socket.send(`< REP FW_VER ${this.p300String('4.3.8', 18)} >`);
                },
            },
            {
                regExp: /^< GET PRESET(\d+)/,
                callback: (match) => {
                    const channelNumber = parseInt(match[1]);
                    const preset = this.presets[channelNumber - 1];
                    if (preset === undefined || this.modelNumber === ModelNumber.IntelliMixRoom) {
                        // IntelliMixRoom v3.2.3 doesn't have preset names.
                        this.socket.send(`< REP ERR >`);
                        return;
                    }
                    const name = this.p300String(preset.name, 25);
                    this.socket.send(`< REP PRESET${match[1]} ${name} >`);
                },
            },
            {
                regExp: /^< SET (\d+) AUDIO_GAIN_HI_RES (\d+)/,
                callback: (match) => {
                    const channelNumber = parseInt(match[1]);
                    const channel = this.channels[this.modelNumber][channelNumber - 1];
                    const channelKey = channelNumber.toString().padStart(2, '0');
                    if (channel === undefined || channel.isAecRef) {
                        this.socket.send(`< REP ERR >`);
                        return;
                    }
                    channel.volume = parseInt(match[2]);
                    const value = channel.volume.toString().padStart(4, '0');
                    this.socket.send(`< REP ${channelKey} AUDIO_GAIN_HI_RES ${value} >`);
                },
            },
            {
                regExp: /^< SET (\d+) (AUDIO_MUTE|AUTOMXR_MUTE) (ON|OFF)/,
                callback: (match) => {
                    const channelNumber = parseInt(match[1]);
                    const channel = this.channels[this.modelNumber][channelNumber - 1];
                    const channelKey = channelNumber.toString().padStart(2, '0');
                    if (channel === undefined ||
                        (match[2] === 'AUTOMXR_MUTE' && !channel.isAutomixer) ||
                        (match[2] === 'AUDIO_MUTE' && channel.isAutomixer) ||
                        channel.isAecRef) {
                        this.socket.send(`< REP ERR >`);
                        return;
                    }
                    channel.mute = match[3] === 'ON';
                    this.socket.send(`< REP ${channelKey} ${match[2]} ${match[3]} >`);
                },
            },
            {
                regExp: /^< SET FLASH (ON|OFF)/,
                callback: (match) => {
                    // IntelliMixRoom v 3.2.3 doesn't support FLASH command.
                    this.socket.send(this.modelNumber !== ModelNumber.IntelliMixRoom
                        ? `< REP FLASH ${match[1]} >`
                        : `< REP ERR >`);
                },
            },
            {
                regExp: /^< SET PRESET (\d+)/,
                callback: (match) => {
                    const channelNumber = parseInt(match[1]);
                    const preset = this.presets[channelNumber - 1];
                    const channelKey = channelNumber.toString().padStart(2, '0');
                    if (preset === undefined) {
                        this.socket.send(`< REP ERR >`);
                        return;
                    }
                    this.socket.send(`< REP PRESET ${channelKey} >`);
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send(`< REP ERR >`);
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['>'],
        };
        this.sendTerminator = '';
    }
    onConfigure(config) {
        var _a;
        this.modelNumber = (_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : ModelNumber.P300;
        if (this.modelNumber in P300.deviceNames) {
            this.deviceName = P300.deviceNames[this.modelNumber];
        }
        else {
            this.modelNumber = P300.deviceNames[ModelNumber.P300];
        }
    }
    p300String(value, length) {
        return `{${value.padEnd(length, ' ')}}`;
    }
}
P300.emulatorType = 'socketEmulator';
P300.key = '-L0oCNdkw3P7BJg9JwVr';
P300.deviceNames = {
    [ModelNumber.ANIUSB]: 'ANIUSB',
    [ModelNumber.IntelliMixRoom]: 'IntelliMixRoom',
    [ModelNumber.MXA910]: 'MXA910',
    [ModelNumber.P300]: 'P300',
};
